import styled from 'styled-components/macro';

export const RootLayoutContainer = styled.div<{ fixedHeight: boolean }>`
  display: flex;
  flex-flow: column nowrap;
  flex-grow: 1;
  background: ${({ theme }) => theme.background.primary};
  height: ${({ fixedHeight }) => fixedHeight && '100vh'};
  max-height: ${({ fixedHeight }) => fixedHeight && '100vh'};
`;
export const RootLayoutBody = styled.div<{ fixedHeight: boolean }>`
  display: flex;
  flex-flow: column nowrap;
  flex-grow: 1;
  flex-shrink: 1;
  overflow-y: ${({ fixedHeight }) => fixedHeight && 'hidden'};
  overflow-x: hidden;
`;
export const RootLayoutSticky = styled.div`
  position: sticky;
  bottom: 0;
  display: flex;
  flex-flow: column nowrap;
  z-index: 10000;
`;
